import { WEB_ROUTES } from '~/utils/webConfig';

export default ({ app, softRedirect }) => {
  if (!app.$auth.loggedIn) {
    return softRedirect(app.localePath(WEB_ROUTES.LOGIN));
  }
};
